document.addEventListener('play', e => {
  if (!e.target.classList.contains('vn-podcast__audio')) return;
  document.querySelectorAll('.vn-podcast__audio').forEach(a => {
    if (a !== e.target && !a.paused) a.pause();
  });
}, true);